/**
 * A random id for in-browser bookkeeping (tab ids, upload keys). `crypto.randomUUID` exists
 * only in secure contexts (HTTPS or localhost), so on a plain-HTTP address such as a phone
 * testing a dev server over Wi-Fi it is missing; `getRandomValues` works everywhere.
 */
export function randomId(): string {
  if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();
  return Array.from(crypto.getRandomValues(new Uint8Array(16)), (b) =>
    b.toString(16).padStart(2, '0'),
  ).join('');
}
